import {Form, Select, Switch} from 'antd';
import React from "react";
import FormFieldType from "../../../form/FormElement/formField/FormFieldType";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import {PickerMode} from 'rc-picker/lib/interface';
import MomentJsDateFormat from "../../../../../shared/input/MomentJsDateFormat";
import TimeSectionsPicker from "../../../../../shared/input/TimeSectionsPicker";

export interface IFieldDateOptions {
    datePicker?: PickerMode | 'dateTime'
    dateFormat?: string
}

interface IProps extends IFieldOptionsEditorProps {

}

class FieldDateOptionsEditor extends React.Component<IProps> {

    render() {
        const {buildFieldName, options} = this.props
        return (
            <div>
                <Form.Item name={buildFieldName('datePicker')} label={'Typ vstupu'} rules={[{required: true}]}
                           initialValue={FormFieldType.FIELD_DATE_DATE_PICKER}>
                    <Select>
                        {FormFieldType.FIELD_DATE_PICKER_TYPES.map(type => (
                            <Select.Option key={type.value} value={type.value}>{type.label}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name={buildFieldName('dateFormat')} label={'Formát zobrazení'} initialValue={'LL'}>
                    <MomentJsDateFormat/>
                </Form.Item>
                <Form.Item name={buildFieldName('datePickerFormat')} label={'Formát data'} initialValue={'YYYY-MM-DD'}>
                    <MomentJsDateFormat/>
                </Form.Item>
                <Form.Item name={buildFieldName('datePickerTimeFormat')} label={'Formát času'} initialValue={'HH:mm:ss'}>
                    <MomentJsDateFormat/>
                </Form.Item>
                {options.type === FormFieldType.FIELD_DATE && (
                    <Form.Item name={buildFieldName('datePickerConfirm')} label={'Potvrzovací tlačítko'} valuePropName={'checked'}>
                        <Switch/>
                    </Form.Item>
                )}
                <Form.Item name={buildFieldName('datePickerAllowedFrom')} label={'Povolit zpětne od'}>
                    <TimeSectionsPicker maxSection={'day'}/>
                </Form.Item>
                <Form.Item name={buildFieldName('datePickerAllowedTo')} label={'Povolit do'}>
                    <TimeSectionsPicker maxSection={'day'}/>
                </Form.Item>
            </div>
        )
    }
}


export default FieldDateOptionsEditor